





































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  EmployerSearchResponse,
  employerStatusTypeMap
} from "@/admin/types";
import {
  fundingOptionMap,
  FetchState,
  UserPermission
} from "@/shared/types";
import { Location } from "vue-router";
import { Validator } from "vee-validate";
import * as RouteNames from "@/admin/route-names";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import { formatDateString } from "@/shared/dateString";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useEmployerStore } from "@/admin/store/employer";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePartnerStore } from "@/admin/store/partner";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({
  components: {
    Pagination,
    PageSizeSelectList,
    GenericLoadingSpinner
  }
})
export default class Employers extends Vue {
  $validator: Validator;
  formatDateString = formatDateString;
  fundingOptionMap = fundingOptionMap;
  employerStatusTypeMap = employerStatusTypeMap;
  employers: EmployerSearchResponse[] = [];

  notifierStore = useNotifierStore();
  employerStore = useEmployerStore();
  partnerStore = usePartnerStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop() page: number;

  @Prop() routeToEmployerList: (page: number) => Location;
  RouteNames = RouteNames;

  totalRecords = 0;
  maxScore = 0;
  queryTime = 0;
  pageCount = 0;
  pageSize = 10;
  isSubmitting = false;
  searchTerm = "";
  searchResultCount = 0;
  partnerId = 0;
  includeTerminated = false;

  mounted (): void {
    this.fetchEmployerList();
    this.partnerStore.reload();
  }

  get submitDisabled (): boolean {
    return this.isLoading || this.isSubmitting;
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.fetchEmployerList();
  }

  @Watch("employerStore.employerSearchResult", { deep: true })
  onSearchResultsArrived (): void {
    this.employers = this.employerStore.employerSearchResult.employers;
    this.totalRecords = this.employerStore.employerSearchResult.totalRecords;
    this.maxScore = this.employerStore.employerSearchResult.maxScore;
    this.pageSize = this.employerStore.employerSearchResult.pageSize;
    this.queryTime = this.employerStore.employerSearchResult.queryTime;
    this.pageCount = this.totalRecords < this.pageSize ? 1 :
      Math.floor((this.totalRecords + this.pageSize - 1) / this.pageSize);
  }

  get hasEmployerAccess (): boolean {
    const hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit);
    const hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerView);
    return !this.featureFlagStore.flags.hsa4475allowRolePermissions || hasEditPermission || hasViewPermission;
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToEmployerList(toPage));
  }

  fetchEmployerList (): void {
    this.employerStore.setPageNumber(this.page);
    this.employerStore.getEmployerSearch({
      pageNumber: this.employerStore.pageNumber,
      clearState: false,
      searchTerm: this.searchTerm,
      partnerId: this.partnerId,
      includeTerminated: this.includeTerminated
    } as any)
      .catch(this.handleError);
  }

  onSearch (): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.employerStore.setPageNumber(1);
      this.$router.push(this.routeToEmployerList(1));
      this.fetchEmployerList();
      this.isSubmitting = false;
    }
  }

  clearSearch (): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.searchTerm = "";
      this.partnerId = 0;
      this.employerStore.setPageNumber(1);
      this.$router.push(this.routeToEmployerList(1));
      this.fetchEmployerList();
      this.isSubmitting = false;
    }
  }

  switchPageSize (): void {
    // on switching page size, reset to page 1
    this.employerStore.setPageNumber(1);
    this.$router.push(this.routeToEmployerList(1));
    this.fetchEmployerList();
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
      (err && err.errorMessage) ||
      "Error processing your request. Please try again later"
    );
  }

  routeToEmployer (id) {
    return { name: RouteNames.Employer, params: { employerId: id, tab: "details" } };
  }

  get fieldConfiguration () {
    return [
      { key: "id", label: "#" },
      { key: "name", label: "Name" },
      { key: "partnerName", label: "Partner" },
      { key: "phone", label: "Phone" },
      { key: "dateCreated", label: "Date Created" },
      { key: "dateActivated", label: "Date Activated" },
      { key: "status", label: "Employer Status" },
      { key: "fundingOption", label: "Employer Funding Option" },
      { key: "externalEmployerId", label: "External Employer Id" },
      { key: "employerTaxId", label: "Employer Tax Id" },
    ];
  }

  get isLoading (): boolean {
    return this.employerStore.employerSearchFetchState === FetchState.Loading;
  }
}
